"use strict";

var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13, _context14, _context15;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _addWatchedName = require("./add-watched-name");
_forEachInstanceProperty(_context = _Object$keys(_addWatchedName)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addWatchedName[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addWatchedName[key];
    }
  });
});
var _addWatchedNames = require("./add-watched-names");
_forEachInstanceProperty(_context2 = _Object$keys(_addWatchedNames)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addWatchedNames[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addWatchedNames[key];
    }
  });
});
var _checkIfWatched = require("./check-if-watched");
_forEachInstanceProperty(_context3 = _Object$keys(_checkIfWatched)).call(_context3, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkIfWatched[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkIfWatched[key];
    }
  });
});
var _checkShouldValidate = require("./check-should-validate");
_forEachInstanceProperty(_context4 = _Object$keys(_checkShouldValidate)).call(_context4, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _checkShouldValidate[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _checkShouldValidate[key];
    }
  });
});
var _createInputState = require("./create-input-state");
_forEachInstanceProperty(_context5 = _Object$keys(_createInputState)).call(_context5, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createInputState[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createInputState[key];
    }
  });
});
var _forceUpdate = require("./force-update");
_forEachInstanceProperty(_context6 = _Object$keys(_forceUpdate)).call(_context6, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _forceUpdate[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _forceUpdate[key];
    }
  });
});
var _formModified = require("./form-modified");
_forEachInstanceProperty(_context7 = _Object$keys(_formModified)).call(_context7, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formModified[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formModified[key];
    }
  });
});
var _formMount = require("./form-mount");
_forEachInstanceProperty(_context8 = _Object$keys(_formMount)).call(_context8, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formMount[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formMount[key];
    }
  });
});
var _formReset = require("./form-reset");
_forEachInstanceProperty(_context9 = _Object$keys(_formReset)).call(_context9, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formReset[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formReset[key];
    }
  });
});
var _formUnmount = require("./form-unmount");
_forEachInstanceProperty(_context10 = _Object$keys(_formUnmount)).call(_context10, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _formUnmount[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _formUnmount[key];
    }
  });
});
var _performValidityEffects = require("./perform-validity-effects");
_forEachInstanceProperty(_context11 = _Object$keys(_performValidityEffects)).call(_context11, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _performValidityEffects[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _performValidityEffects[key];
    }
  });
});
var _reconcileInputs = require("./reconcile-inputs");
_forEachInstanceProperty(_context12 = _Object$keys(_reconcileInputs)).call(_context12, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _reconcileInputs[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _reconcileInputs[key];
    }
  });
});
var _updateInputStateValue = require("./update-input-state-value");
_forEachInstanceProperty(_context13 = _Object$keys(_updateInputStateValue)).call(_context13, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateInputStateValue[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateInputStateValue[key];
    }
  });
});
var _updateInputStateValueIfChanged = require("./update-input-state-value-if-changed");
_forEachInstanceProperty(_context14 = _Object$keys(_updateInputStateValueIfChanged)).call(_context14, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateInputStateValueIfChanged[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateInputStateValueIfChanged[key];
    }
  });
});
var _validateInput = require("./validate-input");
_forEachInstanceProperty(_context15 = _Object$keys(_validateInput)).call(_context15, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _validateInput[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _validateInput[key];
    }
  });
});